<template>
    <div v-if="isFrontend" class="fin-pt-3">
        <h3 class="fin-text-base md:fin-text-lg fin-font-thin fin-leading-snug fin-text-primary"> {{ field.label }} </h3>
        <p v-if="field.content" class="fin-mt-4 fin-text-sm md:fin-text-base fin-font-normal"> {{ field.content }} </p>
    </div>
    <div v-else class="fin-pb-2 fin-mb-2 md:fin-pb-5 md:fin-mb-5">
        <h3 class="fin-text-lg md:fin-text-3xl fin-font-thin fin-leading-snug fin-text-primary"> {{ field.label }} </h3>
        <p v-if="field.content" class="fin-mt-4 fin-text-xs sm:fin-text-base md:fin-text-lg fin-font-normal"> {{ field.content }} </p>
    </div>
</template>

<script>
import formMixin from "@tenant/app-form/mixins/formMixin"
import { mapGetters } from 'vuex'

export default {
    name: "PageTitle",

    mixins: [formMixin],

    props: {
        field: {
            required: true,
            type: [Object, Array],
        },
        fieldKey: {
            required: true,
            type: Number,
        },
        path: {
            required: true,
            type: [String, Number]
        },
        value: {
            required: false,
        },
        formStore: {
            required: false,
            type: String,
            default: "formStore"
        },
    },
    computed: {

    },

    data() {
        return {}
    },

    mounted() {},

    methods: {},
}
</script>

<style lang="scss" scoped>
    h3 {
        @apply fin-relative
    }
</style>
